import React, { useEffect, useState } from 'react';
import fetchWrapper from '../../helpers/fetchWrapper';
import { TreeSelect } from 'antd';
const { SHOW_CHILD } = TreeSelect;
const treeData = [
	{
		title: 'Node1',
		value: '0',
		children: [
			{
				title: 'Child Node1',
				value: '01',
			},
		],
	},
	{
		title: 'Node2',
		value: '1',
		children: [
			{
				title: 'Child Node3',
				value: '11',
			},
			{
				title: 'Child Node4',
				value: '12',
			},
			{
				title: 'Child Node5',
				value: '13',
			},
		],
	},
];

const FormTreeSelect = ({
	value = [],
	onChange,
	getEvent,
	name,
	slug,
	dropdownOptions,
	placeholder,
	extra,
	...rest
}) => {
	const [selected, setSelected] = useState([]);
	const [options, setOptions] = useState(treeData);

	const handleChange = (select) => {
		setSelected(select);
		if (onChange) {
			onChange(select);
		}
		if (getEvent) {
			const target = {
				name,
				value: select.map((item) => item),
				selectedItem: select,
				rules: { required: rest?.required },
			};
			getEvent({ target });
		}
	};

	// fetch data
	const fetchData = async () => {
		const response = await fetchWrapper.post('dropdown/dropdowndata', {
			dropdown_slug: slug,
			external_data: extra,
		});

		if (!response.error && response.data) {
			setOptions(response.data);
			if (response.data.length === 1) {
				handleChange(response.data[0].value);
			}
		}
	};

	useEffect(() => {
		if (slug && slug != '') {
			fetchData();
		} else if (dropdownOptions && dropdownOptions != '') {
			const options = JSON.parse(dropdownOptions);
			setOptions(options);
		}
	}, [slug, extra, dropdownOptions]);

	useEffect(() => {
		console.log('selected value', value);
		value.length > 0 && setSelected(value);
	}, [value]);
	return (
		<TreeSelect
			value={selected}
			showArrow
			allowClear
			onChange={handleChange}
			treeData={options}
			treeCheckable={true}
			showCheckedStrategy={SHOW_CHILD}
			placeholder={'Please select'}
			style={{ width: '100%' }}
			{...rest}
		/>
	);
};

export default FormTreeSelect;
